import type { ServiceLabel } from '../types';
import { SERVICE_LABELS, SERVICE_SHORT, SERVICE_COLORS } from '../types';

interface Props {
  value: ServiceLabel;
  onChange: (service: ServiceLabel) => void;
  showAll?: boolean;
}

export function ServiceFilter({ value, onChange, showAll = true }: Props) {
  const labels = showAll ? SERVICE_LABELS : SERVICE_LABELS.slice(1);

  return (
    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
      {labels.map(label => {
        const isActive = value === label;
        const color = SERVICE_COLORS[label];
        return (
          <button
            key={label}
            onClick={() => onChange(label)}
            style={{
              padding: '6px 14px',
              borderRadius: '20px',
              border: `1px solid ${isActive ? color : 'var(--border-subtle)'}`,
              cursor: 'pointer',
              fontSize: '12px',
              fontFamily: 'var(--font-mono)',
              fontWeight: 500,
              background: isActive ? `${color}20` : 'transparent',
              color: isActive ? color : 'var(--text-tertiary)',
              transition: 'all 0.15s ease',
              whiteSpace: 'nowrap',
            }}
          >
            {SERVICE_SHORT[label]}
          </button>
        );
      })}
    </div>
  );
}
